export const formatDeviceName = (device) => {
  if (!device) {
    return '';
  }

  const { model, type, version } = device || {};

  return `${model} ${type} ${version}`.trim();
};
